<template>
  <Coupons :object="object" :params="params" />
</template>

<script>
import {defineComponent} from "vue"
import Coupons from "@/modules/promopushka/pages/coupons/components/Coupons"
import Options from "@/modules/promopushka/pages/coupons/Items/Options"

export default defineComponent({
  name: "Items",
  components: {
    Coupons
  },
  setup() {
    let object = new Options()

    let params = {
      title: "Все скидки",
      page: "items",
    }

    return {
      object,
      params,
    }
  }
})
</script>

<style scoped>

</style>
